/*-------------------------------------------------------------------
Author: Nathan Walsh <nwalsh@awareweb.com>
Date: August 15, 2014
-------------------------------------------------------------------*/
var currentOptionFieldValue;
var currentFacetId;
var currentOptionSelected;
var currentOptions = [];
var previousSelection = null;
var currentNavAnalyticsName = null;
var checkConflicts = true;
var partialLoad = false;
var currentPackagesSelected = [];
var promoPrices = [];
var currentSelections = [];
var arrayIndexToRemove;
var arrayIdToRemove;
var showWarning = true;
var addToCartUrl;
var addToCartItems;
var processingNext = false;
var dataIndex = null;
var noConflict = true;
var showHidePanel = true;
var _itemNotChangedLength = 0;
var _responsiveItemChanged = null;
var _rdo = null;
var _carbCompliantResident = false;
var _carbCompliantRefresh = false;
var _carbCompliantChange = false;
var _carbCompliantChecked = false;
var _carbCompliantId = null;
var _loopChk = null;

$(document).ready(function () {
    $('#btn-next').addClass('disabled');
    $('#btn-next-mobile').addClass('disabled');
    $('#btn-back').addClass('disabled');
    $('#divReview').hide();
    $('#pStartOver').hide();
    $('#divStartOver').hide();
    //$('#divReviewImage').hide();
    $('#buyBox').hide();
    $('#mobileFooterAddCart').hide();

    $(function () {
        const token = $('input[name="__RequestVerificationToken"]').val();

        $.ajaxSetup({
            headers: {
                'RequestVerificationToken': token
            }
        });
    });

    $(document).on("click", ".collapseMobile", function (p) {
        p.preventDefault();
        checkNoConflict();
        var link = $(this);
        var target = link.data('target');
        $(target).slideToggle('slow');
        if (link.hasClass('show')) {
            link.removeClass('show');
        } else {
            link.addClass('show');
        }
    });

    // Load popover
    $(document).on("click", "a.popover", function (p) {
        checkNoConflict();
        p.preventDefault();
        var element = $(this);
        var pTarget = element.attr('href');
        var pPlacement = element.data('placement');
        element.popModal({
            html: $(pTarget),
            placement: pPlacement,
            showCloseBut: true,
            onDocumentClickClose: false,
            inline: true,
            overflowContent: false,
            onLoad: function () { }
        });
    });

    // Load zoom modal
    $(document).on("click", ".zoom-modal", function (z) {
        checkNoConflict();
        if (this.id == 'reviewZoomModal') return;
        z.preventDefault();
        var element = $(this);
        var zTarget = element.attr('href'),
			zTitle = element.attr('title'),
			zImage = element.data('image');
        if (element.data('responsive') != null) {
            $(zTarget).find('.modal-header .modal-title').html(zTitle);
            $(zTarget).find('.modal-body').html('<img class="img-fluid rounded" src="' + zImage + '" alt="' + zTitle + '"/>');
            $(zTarget).modal('show');
        } else {
            $(zTarget).find('.dialogModal_header').html(zTitle);
            $(zTarget).find('.dialogModal_content').html('<img src="' + zImage + '" alt="' + zTitle + '"/>');
            $(zTarget).dialogModal();
        }
    });

    // Landing page modal
    $(document).on("click", ".dialog-modal", function (z) {
        checkNoConflict();
        z.preventDefault();
        var zTarget = $(this).data('href');
        var zModal = $(zTarget);
        $(zTarget).dialogModal();
    });

    // Load review callout modal
    $(document).on("click", ".image-zoom", function (z) {
        checkNoConflict();
        $('#zoom_dialog').dialogModal();
    });

    // Vidyard Video Modal
    var vTarget = [],
		vTitle = [],
		vVideo = [],
		video = [];

    $(document).on("click", ".video-modal", function (v) {
        checkNoConflict();
        var vTarget = $(this).data('target'),
			vTitle = $(this).attr('title'),
			vVideo = $(this).data('video');
        $(vTarget).find('.modal-header .modal-title').html(vTitle);
        $(vTarget).find('.modal-body .vidyard_player').attr('id', 'vidyard_' + vVideo);
        $(vTarget).find('.modal-body iframe').attr('id', 'vidyard_iframe_' + vVideo);
        $(vTarget).find('.modal-body iframe').attr('src', '//play.vidyard.com/' + vVideo + '.html?v=3.1');
        var video = new Vidyard.player(vVideo);
        //Example
        //video.on('pause', function() { alert("Video paused") });
        $(document).on("click", ".close", function () {
            video.pause();
        });
    });

    // Review Modal
    $(document).on("click", "#reviewZoomModal", function (z) {
        checkNoConflict();
        var zTarget = $(this).data('target');
        $(zTarget).dialogModal();
    });

    // Close popover
    $(document).on("click", ".media-thumb", function (z) {
        checkNoConflict();
        window.onbeforeunload = null;
        $('html').popModal("hide");
    });

    // Loads the restart popup and if the user agrees, reloads the rule engine page
    $(document).on("click", ".btn-restart", function (z) {
        checkNoConflict();
        window.onbeforeunload = null;
        if ($(this).data('toggle') != null) return;
        var url = $(this).data('link');
        $('.restart_content').dialogModal({
            onOkBut: function () {
                window.location.href = url;
            }
        });
        $('.dialogModal').addClass('start-over');
    });

    // Loads the restart popup and if the user agrees, reloads the rule engine page
    $(document).on("click", "#btnRestartConfirm", function (z) {
        window.onbeforeunload = null;
        var url = $(this).data('link');
        window.location.href = url;
    });

    // Exception Modal
    $(document).on("change", ".exmodal input:checkbox", function (z) {
        var thisCheck = $(this).parent();
        if ($(this).is(':checked')) {
            $('.exception_content').dialogModal({
                onOkBut: function () { },
                onCancelBut: function () {
                    //uncheck selection
                    thisCheck.find('.checkbox-custom').click();
                }
            });
            $('.dialogModal').addClass('warning-modal');
        }
    });

    // Adds the mobile user's selections to the shopping cart.
    $(document).on("click", "#AddToCartBtn", function () {
        $('#AddToCartBtn').addClass('disabled');
        window.onbeforeunload = null;
        thdAddToCart();
        //addToShoppingCartMobile();
    });

    $(document).on('click', '.radioGroup', function (e) {
        var element = $(this);
        updateRadio(element);
    });

    // Reload models and save carb compliant selection
    $(document).on("change", ".carbCompCheck", function (e) {
        if (_carbCompliantChange) {
            _carbCompliantChange = false;
            return;
        }
        checkNoConflict();
        var checkbox = $(this);
        if (checkbox.is(':checkbox')) {
            var radioDiv = $('.radio-custom-active');
            if (radioDiv.length > 0) {
                _carbCompliantChecked = checkbox.is(':checked');
                _carbCompliantId = checkbox.data('facetid');
                var lateralModal = $('#lateral_dialog');
                if (lateralModal.data('responsive') != null) {
                    _carbCompliantChange = true;
                    lateralModal.modal('show');
                } else {
                    lateralModal.dialogModal({
                        onOkBut: function () {
                            _rdo = radioDiv.parent().find('input[type=radio]').length != 0 ? radioDiv.parent().find('input[type=radio]') : $('input[type=radio]');
                            _responsiveItemChanged = currentSelections != null && currentSelections.length > 0 ? currentSelections[0] : null;
                            arrayIndexToRemove = 0;
                            if (_rdo.length > 0) {
                                updateFutureSelections(true);
                            }
                            // Update the carb compliance information and remove review items
                            _carbCompliantChange = true;
                            updateCarbCompliance(_carbCompliantChecked, _carbCompliantId);
                        },
                        onCancelBut: function () {
                            checkbox.prop("checked", !checkbox.is(':checked')).trigger('change');
                            _carbCompliantChange = false;
                            return;
                        }
                    });
                }
            } else {
                _carbCompliantChecked = checkbox.is(':checked');
                _carbCompliantId = checkbox.data('facetid');
                _rdo = radioDiv.parent().find('input[type=radio]');
                _responsiveItemChanged = currentSelections != null && currentSelections.length > 0 ? currentSelections[0] : null;
                arrayIndexToRemove = 0;
                if (_rdo.length > 0) {
                    updateFutureSelections(true);
                }
                // Update the carb compliance information and remove review items
                _carbCompliantChange = true;
                updateCarbCompliance(_carbCompliantChecked, _carbCompliantId);
            }
        }
    });

    // Load Results and Change panel to active
    $(document).on("change", ".checkGroup", function (e) {
        checkGroupChecked($(this));
    });

    // Saves the user's current selections and loads the next page
    $(document).on("click", "#btn-next, #btn-next-mobile", function (e) {
        checkNoConflict();
        if (processingNext) return;
        var facetNav = $('#divFacetNav');
        var facetType = facetNav.data('facettype');
        var itemNotChanged = $.grep(currentSelections, function (item) {
            return item.FacetId == currentFacetId && item.FacetOptionId == currentOptionSelected;
        });
        if (itemNotChanged.length > 0 && facetType != 'Options Type') {
            facetClick($('#' + facetNav.data('nextid')), false);
            return;
        } else {
            if (facetType == "Basic Type") {
                if (currentOptionSelected == null) return;
            }
            processNext(itemNotChanged.length == 0);
        }
    });

    // Removes previous selections and moves the user to the next facet.
    $(document).on("click", "#btnLateralConfirm", function (e) {
        if (_carbCompliantChange) {
            var radioDiv = $('.radio-custom-active');
            _rdo = radioDiv.parent().find('input[type=radio]');
            _responsiveItemChanged = currentSelections != null && currentSelections.length > 0 ? currentSelections[0] : null;
            arrayIndexToRemove = 0;
            if (_rdo.length > 0) {
                updateFutureSelections(true);
            }
            // Update the carb compliance information and remove review items
            updateCarbCompliance(_carbCompliantChecked, _carbCompliantId);
        } else {
            updateFutureSelections(_itemNotChangedLength == 0);
            handleRadioUpdate(_rdo);
            _rdo = null;
            _responsiveItemChanged = null;
        }
        $('#lateral_dialog').modal('hide');
    });

    // Cancels any changes made to selections.
    $(document).on("click", "#btnLateralCancel", function (e) {
        if (_carbCompliantChange) {
            var carbCheckbox = $(".carbCompCheck");
            if (carbCheckbox.is(':checkbox')) {
                carbCheckbox.prop("checked", !carbCheckbox.is(':checked')).trigger('change');
            }
            _carbCompliantChange = false;
        } else {
            var item = _responsiveItemChanged[0];
            $("input:radio").attr("checked", false);
            // Change panel to active
            _rdo.parents('.selection-group').find('.card').removeClass('active');

            var radio = $('[data-facetoptionid=' + item.FacetOptionId + ']');
            if (radio != null) {
                radio.prop('checked', true);
                radio.closest('.card').addClass('active');
                currentOptionSelected = item.FacetOptionId;
                currentOptionFieldValue = item.Value;
                radio.trigger('change');
                radio.trigger('click');
            }
            _rdo = null;
            _responsiveItemChanged = null;
        }
        $('#lateral_dialog').modal('hide');
    });

    // Loads the previous facet page
    $(document).on("click", "#btn-back", function (e) {
        var facetId = $('#divFacetNav').data('backid');
        if (facetId == null || facetId == "") return;
        $('#' + facetId).trigger("click");
    });

    // Closes any open popups and loads the mobile review panel
    $(document).on('click', ".reviewEdit", function (e) {
        checkNoConflict();
        e.preventDefault();
        $('html').popModal("hide");
        showHidePanel = false;
        $($(this).attr('href')).trigger('click');
    });

    // Closes any open popups and loads the mobile responsive review panel
    $(document).on('click', ".reviewEditResp", function (e) {
        var popover = $(this).data('popover');
        $('#' + popover).modal('hide');
        var tartget = $(this).data('target');
        $('#' + popover).on('hidden.bs.modal', function (e) {
            $(tartget).trigger('click');
        });
    });

    // Handles the rule engine progress bar click event
    $(document).on("click", ".facetLink, .btn-secondary, .btn-white", function (e) {
        //e.preventDefault();
        checkNoConflict();
        facetClick($(this), true);
    });

    // Mobile Results Drawer
    $(document).on("click", ".selector-footer .showHide", function (e) {
        if (currentSelections.length > 0 || currentFacetId != null) {
            $(this).toggleClass('on');
            $('.selector-footer .showHide .showing, .selector-footer .showHide .hiding, #divFacet, .title').toggleClass('d-none');

            $('.item .title').removeClass('d-none');
            $('#divRuleEngineReview').fadeToggle();
            $('#tororesults').fadeToggle();
        }
    });

    // Load Results and Change panel to active
    $(document).on("change", "input:checkbox.toro", function (e) {
        checkboxChange(this);
    });

    // Removes the selection of the conflicting option.
    $(document).on("click", "#btnConflictConfirm", function (e) {
        var confirmButton = $('#btnConflictConfirm');
        var chkId = confirmButton.data('checkboxid');
        var checkBox = $('#' + chkId);
        //uncheck selection
        checkConflicts = false;
        checkBox.prop('checked', false).change();
        checkConflicts = true;
        $('#conflictModal').modal('hide');
    });

    if (!Boss.ruleEngineItems().isLanding) {
        markCompletedFacets(Boss.ruleEngineItems().completedFacets);
        markActiveFacet(Boss.ruleEngineItems().currentFacet.Id);
        updateFacetTitle(Boss.ruleEngineItems().currentFacet.id);
    }
    // Adds the breadcrumb items to the page if they are present.
    if (Boss.ruleEngineItems().breadcrumbLink != null && Boss.ruleEngineItems().breadcrumbLink != '') {
        var breadcrumbLink = $('#breadcrumbLink');
        breadcrumbLink.attr('href', Boss.ruleEngineItems().breadcrumbLink);
        breadcrumbLink.text(Boss.ruleEngineItems().breadcrumbText);
    }


    if (!Boss.ruleEngineItems().isLanding) {
        // Added function to warn users about navigating away from the current page.
        window.onbeforeunload = function () {
            return Boss.ruleEngineItems().backMessage;
        }
    }

    // Fixes scrolling issue with mobile review section showing.
    $(window).scroll(function () {
        if ($("header.fixedsticky").hasClass('fixedsticky-on')) {
            $('#tororesults').addClass('sticky-on');
            $('#tororesults').removeClass('fixedsticky');
        } else {
            $('#tororesults').removeClass('sticky-on');
        }
        if ($('body').scrollTop() <= 49) {
            $('#tororesults').removeClass('sticky-on');
        }
    });

    //Check for pre-checked option on first facet
    if ($('input[type=radio]:checked').length > 0) {
        $('input[type=radio]:checked').trigger('change');
        $('#btn-next').removeClass('disabled');
        $('#btn-next-mobile').removeClass('disabled');
    }
});

// Checks to see if .noConflict should be added or not.
function checkNoConflict() {
    if (typeof $({}).dialogModal != 'function' && Boss.ruleEngineItems().deviceType == 'mobile') {
        jQuery.noConflict(true);
        noConflict = true;
        return;
    }
    if (noConflict == false && Boss.ruleEngineItems().deviceType == 'mobile') {
        jQuery.noConflict();
        noConflict = true;
    }
}

// String formatting function.
String.prototype.format = String.prototype.f = function () {
    var s = this,
        i = arguments.length;

    while (i--) {
        s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
    }
    return s;
};

// Shows code error message dialog
function showErrorDialog(errorMessage) {
    var errorDialog = $('#codeError_dialog');
    if (errorDialog.data('showfriendlymessage') != true && errorMessage != null && errorMessage != '') {
        errorDialog.find('.dialogModal_content').text(errorMessage);
    }
    if (errorDialog.data('responsive') == true) {
        errorDialog.modal('show');
    } else {
        errorDialog.dialogModal();
    }
}

// Updates available model list based on Carb Compliance selection.
function updateCarbCompliance(isResident, facetId) {
    _carbCompliantResident = isResident;
    _carbCompliantRefresh = true;
    facetClick($('#' + facetId), true);
    _carbCompliantRefresh = false;
}

// Updates the interface with the radio buttons information.
function updateRadio(rdo) {
    if (rdo.is(":disabled")) return;
    currentFacetId = rdo.data('facetid');
    currentOptionSelected = rdo.data('facetoptionid');
    currentOptionFieldValue = rdo.data('facetfieldvalue');
    var facetNav = $('#divFacetNav');
    var facetType = facetNav.data('facettype');
    var facetField = facetNav.data('fieldname');
    // handles removing any future changes if needed and determines if processing should continue.
    handleSelctionChange(rdo, facetField, facetType);
}

// Hides previous selections and clears them from the selection objects.
function handleSelctionChange(rdo, facetField, facetType) {
    _itemNotChangedLength = 0;
    var itemNotChanged = $.grep(currentSelections, function (item) {
        return item.FacetId == currentFacetId && item.FacetOptionId == currentOptionSelected;
    });
    if (itemNotChanged.length > 0 && facetType != 'Options Type') {
        return;
    } else {
        var itemChanged = $.grep(currentSelections, function (item) {
            return item.FacetId == currentFacetId;
        });
        if (itemChanged.length > 0 && facetType != 'Options Type') {
            var lateralModal = $('#lateral_dialog');
            if (lateralModal.data('responsive') != null) {
                _rdo = rdo;
                _responsiveItemChanged = itemChanged;
                _itemNotChangedLength = itemNotChanged.length;
                lateralModal.modal('show');
            } else {
                lateralModal.dialogModal({
                    onOkBut: function () {
                        updateFutureSelections(itemNotChanged.length == 0);
                        handleRadioUpdate(rdo);
                    },
                    onCancelBut: function () {
                        var item = itemChanged[0];
                        $("input:radio").attr("checked", false);
                        // Change panel to active
                        rdo.parents('.selection-group').find('.card').removeClass('active');

                        var radio = $('[data-facetoptionid=' + item.FacetOptionId + ']');
                        if (radio != null) {
                            radio.prop('checked', true);
                            radio.closest('.card').addClass('active');
                            currentOptionSelected = item.FacetOptionId;
                            currentOptionFieldValue = item.Value;
                            radio.trigger('change');
                            radio.trigger('click');
                        }
                        return;
                    }
                });
            }
        } else {
            updateFutureSelections(itemNotChanged.length == 0);
            handleRadioUpdate(rdo);
        }
    }
}

// Clears all the future selections.
function updateFutureSelections(itemChanged) {
    var facetNav = $('#divFacetNav');
    var facetType = facetNav.data('facettype');
    if (arrayIndexToRemove != null) {
        // Get the options facet selection item
        var optionsSelectedItem = $.grep(currentSelections, function (item) {
            return item.FacetType == 'Options Type';
        });
        if (optionsSelectedItem != null && optionsSelectedItem.length > 0) {
            var id = optionsSelectedItem[0].FacetId;
            var index = $('#' + id).data('index');
            if (index > arrayIndexToRemove) {
                $.each(currentOptions, function (i, v) {
                    $('.' + v).hide();
                    toggleImageLayer(v, false);
                });
                currentOptions = [];
                uncheckSelectedOptions();
                $.each(currentPackagesSelected, function (i, v) {
                    unselectCheckbox($('#' + v));
                });
                currentPackagesSelected = [];
            }
        }
        if (itemChanged) {
            if (facetType != 'Warranty Type') {
                var warrantySelections = $.grep(currentSelections, function (facet) {
                    return facet.FacetType == "Warranty Type";
                });
                if (warrantySelections.length > 0) {
                    $('[data-type="Warranty"]').removeClass('visible').hide();
                }
            }
            currentSelections.splice(arrayIndexToRemove, currentSelections.length - (arrayIndexToRemove));
        }
        arrayIndexToRemove = null;
        var facets = $('#' + arrayIdToRemove).parent().nextAll().find('a');
        var facetNavs = $('#' + arrayIdToRemove + '.mobilenav').parent().nextAll().find('a');
        facets.each(function () {
            var facetType2 = $(this).data('facettype');
            if (facetType2 != 'Options Type') {
                hideFields(this.id);
            } else {
                $('#results-container #custom1').empty();
            }
        });
        undoCompletedFacets(facets);
        undoCompletedFacets(facetNavs);
        arrayIdToRemove = null;
    }
}

// Handles radio change events
function handleRadioUpdate(rdo) {
    var facetNav = $('#divFacetNav');
    var facetType = facetNav.data('facettype');
    var facetField = facetNav.data('fieldname');

    $("input:radio").attr("checked", false);
    // Change panel to active
    rdo.parents('.selection-group').find('.card').removeClass('active');
    rdo.closest('.card').addClass('active');

    // Load Results
    var oResultsContainer = $('#results-container'),
        oResultsInner = $('#results-container div.inner'),
        uLoader = $('#results-container').find('div.template-ajax-loading');
    // Activate next button
    $('#btn-next').removeClass('disabled');
    $('#btn-next-mobile').removeClass('disabled');

    // Toggle loading
    if (uLoader.hasClass('hidden')) {
        // First Time Activating
        uLoader.toggleClass('hidden');
    }
    rdo.attr('checked', true);
    var facetSelections = JSON.parse(JSON.stringify(currentSelections));

    var existing = $.grep(facetSelections, function (item) {
        return item.FacetId == currentFacetId && item.FacetOptionId == currentOptionSelected;
    });
    if (existing.length > 0) {
        uLoader.addClass('hidden');
        oResultsInner.addClass('showing');
        return;
    }
    facetSelections.push({
        FacetId: currentFacetId,
        FieldName: facetField,
        Value: currentOptionFieldValue,
        FacetType: facetType,
        FacetOptionId: currentOptionSelected
    });
    var selectedValues = JSON.stringify({
        facetOptionId: currentOptionSelected,
        facetId: currentFacetId,
        currentSelections: facetSelections,
        //searchPath: Boss.ruleEngineItems().searchPath,
        //priceField: Boss.ruleEngineItems().priceField,
        //promoPriceField: Boss.ruleEngineItems().promoPriceField,
        componentId: Boss.ruleEngineItems().facetComponent.Id,
        modelInfos: Boss.ruleEngineItems().modelInfos,
        //carbCompliantResident: _carbCompliantResident
    });
    $.ajax({
        url: '/BossRuleEngine/GetFacetOption',
        type: "post",
        dataType: 'json',
        data: selectedValues,
        contentType: "application/json; charset=utf-8",
        success: function (data) {
           // if (data.Success == true) {
                //if (facetType == 'Warranty Type') {
                //    promoPrices = jQuery.grep(promoPrices, function (value) {
                //        return value.optionId != currentFacetId;
                //    });
                //    updateFieldsWithPrice(data, oResultsContainer, currentFacetId);
                //} else if (facetType == 'Basic Type') {
                    updateFields(data, oResultsContainer, currentFacetId);
              //  }
            //} else {
            //    showErrorDialog(data.Message);
            //}
            uLoader.addClass('hidden');
            oResultsInner.addClass('showing');
        },
        error: function (result) {
            uLoader.addClass('hidden');
            oResultsInner.addClass('showing');
            showErrorDialog(result.Message);
        }
    });
}

// Handles the checkbox group checked event
function checkGroupChecked(checkbox) {
    checkNoConflict();
    // Change panel to active
    checkbox.closest('.card').toggleClass('active');

    // Load Results
    var oResultsInner = $('#results-container div.inner'),
        uLoader = $('#results-container').find('div.template-ajax-loading');

    // Toggle loading
    if (uLoader.hasClass('hidden')) {
        // First Time Activating
        uLoader.toggleClass('hidden');
    }
    var checked = checkbox.is(':checked');
    var iCheck = checked ? 'true' : 'false';

    currentFacetId = checkbox.data('facetid');
    currentOptionSelected = checkbox.data('facetoptionid');
    currentOptionFieldValue = checkbox.data('facetfieldvalue');
    var index = checkbox.data('index');
    var isWarranty = checkbox.data('iswarranty');
    if (isWarranty == null) {
        if ($.inArray(currentOptionFieldValue, currentPackagesSelected) >= 0) {
            if (!checked) {
                currentPackagesSelected.splice($.inArray(currentOptionFieldValue, currentPackagesSelected), 1);
            }
        } else if (checked) {
            currentPackagesSelected.push(currentOptionFieldValue);
        }

        checkSelectedPackage(checkbox, iCheck);
        uLoader.addClass('hidden');
        oResultsInner.addClass('showing');
    } else {
        var facetNav = $('#divFacetNav');
        var facetType = facetNav.data('facettype');
        var facetField = facetNav.data('fieldname');
        var oResultsContainer = $('#results-container');
        var facetSelections = JSON.parse(JSON.stringify(currentSelections));
        if ($.inArray(currentOptionFieldValue, currentPackagesSelected) >= 0) {
            if (!checked) {
                facetSelections.splice($.inArray(currentOptionFieldValue, facetSelections), 1);
                hideFields(currentFacetId);
            }
        } else if (checked) {
            facetSelections.push({
                FacetId: currentFacetId,
                FieldName: facetField,
                Value: currentOptionFieldValue,
                FacetType: facetType,
                FacetOptionId: currentOptionSelected
            });
            dataIndex = checkbox.data('index');
        }
        var selectedValues = JSON.stringify({
            facetOptionId: currentOptionSelected,
            facetId: currentFacetId,
            currentSelections: facetSelections,
            searchPath: Boss.ruleEngineItems().searchPath,
            priceField: Boss.ruleEngineItems().priceField,
            promoPriceField: Boss.ruleEngineItems().promoPriceField,
            componentId: Boss.ruleEngineItems().facetComponent.Id,
            modelInfos: Boss.ruleEngineItems().modelInfos,
            carbCompliantResident: _carbCompliantResident
        });
        $.ajax({
            url: '/BossRuleEngine/GetFacetOption',
            type: "post",
            dataType: 'json',
            data: selectedValues,
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                if (data.Success == true) {
                    uLoader.addClass('hidden');
                    oResultsInner.addClass('showing');
                    updateWarrantyPrice(data.Result, oResultsContainer, currentFacetId, iCheck, index);
                } else {
                    uLoader.addClass('hidden');
                    oResultsInner.addClass('showing');
                    showErrorDialog(data.Message);
                }
                if (!checked) {
                    currentOptionSelected = null;
                    currentOptionFieldValue = null;
                    promoPrices = jQuery.grep(promoPrices, function (value) {
                        return value.optionId != currentFacetId;
                    });
                }
            },
            error: function (err) {
                uLoader.addClass('hidden');
                oResultsInner.addClass('showing');
                showErrorDialog(err.Message);
            }
        });
    }
}

// Processes the next button functionality.
function processNext(itemChanged) {
    var facetNav = $('#divFacetNav');
    var facetType = facetNav.data('facettype');
    //if (facetType == "Basic Type") {
    //    if (currentOptionSelected == null) return;
    //}
    var facetId = facetNav.data('nextid');
    var facetField = facetNav.data('fieldname');
    if (arrayIndexToRemove != null) {
        // Get the options facet selection item
        var optionsSelectedItem = $.grep(currentSelections, function (item) {
            return item.FacetType == 'Options Type';
        });
        if (optionsSelectedItem != null && optionsSelectedItem.length > 0) {
            var id = optionsSelectedItem[0].FacetId;
            var index = $('#' + id).data('index');
            if (index > arrayIndexToRemove) {
                $.each(currentOptions, function (i, v) {
                    $('.' + v).hide();
                    toggleImageLayer(v, false);
                });
                currentOptions = [];
                uncheckSelectedOptions();
                $.each(currentPackagesSelected, function (i, v) {
                    unselectCheckbox($('#' + v));
                });
                currentPackagesSelected = [];
            }
        }
        if (itemChanged) {
            if (facetType != 'Warranty Type') {
                var warrantySelections = $.grep(currentSelections, function (facet) {
                    return facet.FacetType == "Warranty Type";
                });
                if (warrantySelections.length > 0) {
                    $('[data-type="Warranty"]').removeClass('visible').hide();
                }
            }
            currentSelections.splice(arrayIndexToRemove, currentSelections.length - (arrayIndexToRemove));
        }
        arrayIndexToRemove = null;
        var facets = $('#' + arrayIdToRemove).parent().nextAll().find('a');
        var facetNavs = $('#' + arrayIdToRemove + '.mobilenav').parent().nextAll().find('a');
        facets.each(function () {
            var facetType2 = $(this).data('facettype');
            if (facetType2 != 'Options Type') {
                hideFields(this.id);
            } else {
                $('#custom1 div.item.visible').hide();
                $('#custom1 div.item.visible').removeClass('visible');
            }
        });
        undoCompletedFacets(facets);
        undoCompletedFacets(facetNavs);
        arrayIdToRemove = null;
    }
    if (itemChanged) {
        currentSelections.push({
            FacetId: currentFacetId,
            FieldName: facetField,
            Value: currentOptionFieldValue,
            FacetType: facetType,
            FacetOptionId: currentOptionSelected,
            DataIndex: dataIndex
        });
    }
    dataIndex = null;
    if (facetType == 'Options Type') {
        currentOptions = [];
        updateCurrentOptions(currentOptions);
    }
    var selectedValues = JSON.stringify({
        facetId: facetId,
        componentId: Boss.ruleEngineItems().facetComponent.Id,
        currentSelections: currentSelections,
        currentOptions: currentOptions,
        modelInfos: Boss.ruleEngineItems().modelInfos,
    });
    processingNext = true;
    $.ajax({
        url: '/BossRuleEngine/GetFacet',
        type: "post",
        dataType: "json",
        data: selectedValues,
        contentType: "application/json; charset=utf-8",
        success: function (result) {
            if (result.Success) {
                updatePrice($('#lowestPrice').data('baseprice'));
                undoActiveFacets($('a.active'));
                undoActiveFacets($('a.active.mobilenav'));
                markCompletedFacet(currentFacetId);
                markActiveFacet(facetId);
                updateFacetTitle(facetId);
                currentFacetId = facetId;
                var currentIndex = $('#' + facetId).data('index');
                $('#currentStep').text(currentIndex + 1);
                $('#currentStepFooter').text(currentIndex + 1);
                currentOptionSelected = null;
                sendAnalyticsData(result, facetType);
                if (result.Result.ViewType == 'Review Type') {
                    showHideReviewPage(result);
                } else {
                    showHideBasicPages(result);
                    var warrantySels = $.grep(currentSelections, function (facet) {
                        return facet.FacetType == "Warranty Type";
                    });
                    if (warrantySels.length > 0 && result.Result.ViewType == 'Warranty Type') {
                        checkSelectedWarranties(warrantySels);
                        $('#btn-next').removeClass('disabled');
                        $('#btn-next-mobile').removeClass('disabled');
                    }
                    var thdFormSelecter2 = $("input[type=radio]");
                    thdForms.radioButtons.init(thdFormSelecter2);
                    var thdFormSelecter1 = $("input[type=checkbox]");
                    thdForms.checkBoxes.init(thdFormSelecter1);
                    checkConflicts = false;
                    updateCheckboxes();
                    checkConflicts = true;
                    if (result.Result.ViewType == 'Options Type') {
                        loadImageLayers(result.Result.ImageLayers);
                        loadInstallations(result.Result.Installations);
                        $('.panel.active').removeClass('active');
                        $('#btn-next').removeClass('disabled');
                        $('#btn-next-mobile').removeClass('disabled');
                    } else {
                        if ($('input[type=radio]:checked').length > 0) {
                            $('input[type=radio]:checked').each(function () {
                                updateRadio($(this));
                            });
                            if (Boss.ruleEngineItems().deviceType != null && Boss.ruleEngineItems().deviceType != 'default') {
                                $('input[type=radio]:checked').trigger('change');
                            }
                            $('#btn-next').removeClass('disabled');
                            $('#btn-next-mobile').removeClass('disabled');
                            if (arrayIndexToRemove >= 0)
                                $('#btn-back').removeClass('disabled');
                        } else if ($('input[type=checkbox]:checked').length > 0) {
                            //$('input[type=checkbox]:checked').trigger('change');
                            $('input[type=checkbox]:checked').each(function (ind) {
                                checkGroupChecked($(this));
                            });
                            $('#btn-next').removeClass('disabled');
                            $('#btn-next-mobile').removeClass('disabled');
                            if (arrayIndexToRemove >= 0)
                                $('#btn-back').removeClass('disabled');
                        } else {
                            $('#btn-next').addClass('disabled');
                            $('#btn-next-mobile').addClass('disabled');
                        }
                    }
                    $('#btn-back').removeClass('disabled');
                    var uLoader = $('#results-container').find('div.template-ajax-loading');
                    uLoader.addClass('hidden');
                }
            } else {
                showErrorDialog(result.Message);
            }
            processingNext = false;
        },
        error: function (result) {
            processingNext = false;
            showErrorDialog(result.Message);
        }
    });
}

// Hides and shows the appropriate html for the basic pages.
function showHideBasicPages(result) {
    $('#btn-next').addClass('disabled');
    $('#btn-next-mobile').addClass('disabled');
    $('#divFacet').html(result.Html);
    $('#divReview').html('');
    $('#divReview').hide();
    $('#divRuleEngine').show();
    $('#divRuleEngineReview').show();
    $('#pStartOver').hide();
    $('#divStartOver').hide();
    $('#mobileFooterNav').show();
    $('#mobileFooterAddCart').hide();
    if (Boss.ruleEngineItems().deviceType == 'mobile') {
        $('#reviewShowHide').show();
        $('#reviewSteps').show();
        $('#buyBox').hide();
    }
    var mSteps = $('#mSteps:visible');
    if ((mSteps == null || mSteps.length == 0) && Boss.ruleEngineItems().deviceType != 'mobile') {
        $('#tororesults').show();
    }
}

// Hides and shows the appropriate html for the review page.
function showHideReviewPage(result) {
    $('#divRuleEngine').hide();
    $('#divRuleEngineReview').hide();
    $('#tororesults').hide();
    $('#divReview').html(result.Html);
    $('#divFacet').html('');
    $('#divReview').show();
    $('#pStartOver').show();
    $('#divStartOver').show();
    $('#mobileFooterNav').hide();
    $('#mobileFooterAddCart').show();
    if (Boss.ruleEngineItems().deviceType == 'mobile') {
        $('#reviewShowHide').hide();
        $('#reviewSteps').hide();
        $('#buyBox').show();
    }
}

// Sends the toro analytics data to the google tag manager code.
function sendAnalyticsData(result, facetType) {
    var href = $(location).attr('href').split('#')[0];
    href += '?step=' + currentNavAnalyticsName;
    //if (facetType == 'Options Type') {
    //    dataLayer.push({
    //        'event': 'page',
    //        'destinationURL': href,
    //        'currentStep': currentNavAnalyticsName
    //    });
    //} else {
    //    dataLayer.push({
    //        'event': 'page',
    //        'destinationURL': href,
    //        'currentStep': currentNavAnalyticsName,
    //        'previousSelection': previousSelection
    //    });
    //}
    previousSelection = null;
    currentNavAnalyticsName = null;
}

// Sends the toro analytics data to the google tag manager code for the initial facet
Boss.ruleEngineLoaded = function () {
    var facetId = Boss.ruleEngineItems().currentFacet.Id;
    //if (facetId != null) {
    //    var facet = $('#' + facetId);
    //    var facetAnalyticsName = facet.data('analyticsname');
    //    var href = $(location).attr('href').split('#')[0];
    //    href += '?step=' + facetAnalyticsName;
    //    dataLayer.push({
    //        'event': 'page',
    //        'destinationURL': href,
    //        'currentStep': facetAnalyticsName
    //    });
    //}
}

// Handles the nav link click events
function facetClick(link, showHide) {
    var href = link.attr('href');
    if (href == null || href == "") return;
    if (!_carbCompliantChange) {
        var collapse = $('#collapseOne');
        if (collapse != null && collapse.length > 0) {
            collapse.collapse('hide');
        }
    }
    var previousId;
    if (arrayIdToRemove != null) {
        previousId = JSON.parse(JSON.stringify(arrayIdToRemove));
    }
    var facetNav = $('#divFacetNav');
    var facetType = facetNav.data('facettype');
    arrayIdToRemove = link.attr('id');
    arrayIndexToRemove = link.data('index');
    if (currentSelections.length > 0 && currentSelections.length >= arrayIndexToRemove) {
        var difference = $.grep(currentSelections, function (facet) { return facet.FacetId == arrayIdToRemove; });
        if (difference.length == 0 && arrayIndexToRemove != currentSelections.length && facetType != 'Warranty Type') return;
    } else {
        if (!_carbCompliantRefresh) return;
    }
    if (previousId != null) {
        var previousItem = $('#' + previousId);
        var previousItemNav = $('#' + previousId + '.mobilenav');
        previousItem.removeClass('active');
        previousItemNav.removeClass('active');
        previousItemNav.parent().removeClass('active');
        if (!previousItemNav.hasClass('complete') && !previousItemNav.hasClass('last')) {
            previousItemNav.parent().addClass('disabled');
        } else {
            previousItemNav.parent().addClass('complete');
        }
        if (Boss.ruleEngineItems().deviceType == "mobile") {
            if (previousItem.data('index') < currentSelections.length) {
                previousItem.removeClass('btn-white');
                previousItem.addClass('btn-secondary');
            }
        }
    }
    var warrantySelections = $.grep(currentSelections, function (facet) {
        return facet.FacetType == "Warranty Type";
    });
    if (warrantySelections.length == 0) {
        $('[data-type="Warranty"]').removeClass('visible').hide();
    }
    if (currentOptions == null || currentOptions.length == 0) {
        $('#custom1 div.item.visible').hide();
        $('#custom1 div.item.visible').removeClass('visible');
        if (Boss.ruleEngineItems().deviceType != null && Boss.ruleEngineItems().deviceType == 'mobile') {
            $('.item.visible').each(function (i) {
                $(this).removeClass('visible');
            });
        }
        currentPackagesSelected = [];
        $(".img-Option").each(function () {
            toggleImageLayer(this.id.substring(3), false);
        });
    }
    var selectedValues = JSON.stringify({
        facetId: arrayIdToRemove,
        componentId: Boss.ruleEngineItems().facetComponent.Id,
        currentSelections: currentSelections,
        currentOptions: currentOptions,
        includeCurrent: false,
        modelInfos: Boss.ruleEngineItems().modelInfos,
    });
    $.ajax({
        url: '/BossRuleEngine/GetFacet',
        type: "post",
        dataType: "json",
        data: selectedValues,
        contentType: "application/json; charset=utf-8",
        success: function (result) {
            if (result.Success) {
                partialLoad = true;
                if (facetType == 'Options Type' && arrayIdToRemove == null) {
                    uncheckSelectedOptions();
                } else if (arrayIdToRemove == null) {
                    hideFields(currentFacetId);
                }
                markActiveFacet(arrayIdToRemove);
                updateFacetTitle(arrayIdToRemove);
                var currentIndex = $('#' + arrayIdToRemove).data('index');
                $('#currentStep').text(currentIndex + 1);
                $('#currentStepFooter').text(currentIndex + 1);
                currentFacetId = arrayIdToRemove;
                currentOptionSelected = null;
                if (result.Result.ViewType == 'Review Type') {
                    showHideReviewPage(result);
                } else {
                    //if (!_carbCompliantChange) {
                    showHideBasicPages(result);
                    //}
                    checkConflicts = false;
                    if (result.Result.ViewType == 'Options Type') {
                        loadImageLayers(result.Result.ImageLayers);
                        loadInstallations(result.Result.Installations);
                        $('#btn-next').removeClass('disabled');
                        $('#btn-next-mobile').removeClass('disabled');
                    }
                    if (result.Result.ViewType != 'Options Type') {
                        var selection = currentSelections[arrayIndexToRemove];
                        var radio;
                        if (selection != null && selection.Value != null) {
                            radio = $('[data-facetoptionid=' + selection.FacetOptionId + ']');
                            if (radio != null) {
                                radio.prop('checked', true);
                                radio.closest('.card').addClass('active');
                                currentOptionSelected = radio.data('facetoptionid');
                                currentOptionFieldValue = radio.data('facetfieldvalue');
                                $('#btn-next').removeClass('disabled');
                                $('#btn-next-mobile').removeClass('disabled');
                                if (arrayIndexToRemove >= 0)
                                    $('#btn-back').removeClass('disabled');
                            }
                        }
                    } else if (currentPackagesSelected.length > 0) {
                        var packages = JSON.parse(JSON.stringify(currentPackagesSelected));
                        updateCheckboxes();
                        currentPackagesSelected = JSON.parse(JSON.stringify(packages));
                        $.each(currentPackagesSelected, function (i, val) {
                            var chk = $('#' + String(val).replace(' ', ''));
                            if (chk != null) {
                                chk.prop('checked', true);
                                chk.removeClass('checkbox-custom').addClass('checkbox-custom-active');
                                //checkSelectedPackage(chk, true);
                            }
                        });
                    }
                    if ($('input[type=radio]:checked').length > 0) {
                        $('#btn-next').removeClass('disabled');
                        $('#btn-next-mobile').removeClass('disabled');
                        if (arrayIndexToRemove >= 0)
                            $('#btn-back').removeClass('disabled');
                    }
                    checkConflicts = false;
                    if (currentOptions.length > 0) {
                        checkSelectedOptions();
                        if (result.Result.ViewType == 'Options Type') {
                            $('#btn-next').removeClass('disabled');
                            $('#btn-next-mobile').removeClass('disabled');
                        }
                    }
                    if (warrantySelections.length > 0 && result.Result.ViewType == 'Warranty Type') {
                        checkSelectedWarranties(warrantySelections);
                        $('#btn-next').removeClass('disabled');
                        $('#btn-next-mobile').removeClass('disabled');
                    }
                    checkConflicts = true;
                    var thdFormSelecter2 = $("input[type=radio]");
                    thdForms.radioButtons.init(thdFormSelecter2);
                    var thdFormSelecter1 = $("input[type=checkbox]");
                    thdForms.checkBoxes.init(thdFormSelecter1);
                    if (currentOptions.length > 0 && radio != null
                        && radio.data('package') != null && radio.data('package') != '') {
                        checkSelectedPackage(radio);
                    }
                    if ($('input[type=radio]:checked').length > 0) {
                        $('input[type=radio]:checked').trigger('change');
                    }
                    var backFacetId = $('#divFacetNav').data('backid');
                    if (backFacetId == null || backFacetId == "")
                        $('#btn-back').addClass('disabled');
                    else
                        $('#btn-back').removeClass('disabled');
                    partialLoad = false;
                    if (_carbCompliantChange) {
                        hideFields(_carbCompliantId);
                        $('#custom1 div.item.visible').hide();
                        $('#custom1 div.item.visible').removeClass('visible');
                        if (Boss.ruleEngineItems().deviceType != null && Boss.ruleEngineItems().deviceType == 'mobile') {
                            $('.item.visible').each(function (i) {
                                $(this).removeClass('visible');
                            });
                        }
                        currentPackagesSelected = [];
                        $(".img-Option").each(function () {
                            toggleImageLayer(this.id.substring(3), false);
                        });
                        updatePrice('0.00');
                    } else {
                        updatePrice($('#lowestPrice').data('baseprice'));
                    }
                }
                if (showHide && !_carbCompliantChange) {
                    if (!$('.showHide').hasClass('responsive') && showHidePanel) {
                        $('.showHide').trigger('click');
                    } else {
                        showHidePanel = true;
                    }
                }
                _carbCompliantChange = false;
            } else {
                showErrorDialog(result.Message);
            }
        }
    });
}

// Updates the facet title for the current step.
function updateFacetTitle(facetId) {
    var facet = $.grep(Boss.ruleEngineItems().facetComponent.Facets, function (f) {
        return f.Id == facetId;
    });
    if (facet.length > 0 && facet[0].FacetTitle != null && facet[0].FacetTitle != '') {
        $('#facetTitle').html(facet[0].FacetTitle);
    } else {
        $('#facetTitle').html(Boss.ruleEngineItems().facetComponent.Title);
    }
}

// Marks the specified facet as active
function markActiveFacet(facetId) {
    if (facetId != null) {
        var facet = $('#' + facetId);
        var facetNav = $('#' + facetId + '.mobilenav');
        //var navTitle = facet.find('span').text();
        //if (navTitle == null || navTitle == '') {
        //    navTitle = facetNav.text();
        //}
        //if (navTitle.indexOf('<span></span>') >= 0) {
        //    navTitle = navTitle.split('<span></span>')[1];
        //}
        var facetAnalyticsName = facet.data('analyticsname');
        currentNavAnalyticsName = facetAnalyticsName;
        facet.addClass("active");
        facet.parent().addClass('active');
        facetNav.parent().removeClass('disabled');
        facetNav.parent().removeClass('complete');
        facetNav.parent().addClass('active');
        facetNav.addClass('active');
        if (Boss.ruleEngineItems().deviceType == "mobile") {
            facet.addClass('btn-white');
            facet.removeClass("btn-light");
        }
    }
}

// Marks the specified facet as complete
function markCompletedFacet(facetId) {
    if (facetId != null) {
        var facet = $('#' + facetId);
        var facetNav = $('#' + facetId + '.mobilenav');
        facet.removeClass("active");
        facet.addClass("complete");
        facetNav.removeClass("active");
        facetNav.addClass("complete");
        facetNav.parent().removeClass("active");
        facetNav.parent().addClass("complete");
        facetNav.parent().removeClass("disabled");
        if (Boss.ruleEngineItems().deviceType == "mobile") {
            facet.removeClass('btn-white');
            facet.addClass("btn-secondary");
        }
    }
}

// Marks all the facets specified as complete
function markCompletedFacets(facets) {
    for (var i = 0; i < facets.length; i++) {
        var facet = $('#' + facets[i].Id);
        var facetNav = $('#' + facets[i].Id + '.mobilenav');
        facet.addClass("complete");
        facetNav.addClass("complete");
        facetNav.parent().addClass("complete");
        facetNav.parent().removeClass("disabled");
        if (Boss.ruleEngineItems().deviceType == "mobile") {
            facet.addClass("btn-secondary");
        }
    }
}

// Removes the active class from the specified facets
function undoActiveFacets(facets) {
    facets.removeClass("active");
    facets.each(function (index) {
        $(this).parent().removeClass("active");
        if (Boss.ruleEngineItems().deviceType == null || Boss.ruleEngineItems().deviceType != 'tablet') {
            $(this).parent().addClass("disabled");
        }
    });
}

// Removes the complete class from the specified facets
function undoCompletedFacets(facets) {
    facets.removeClass("complete");
    facets.each(function (index) {
        $(this).parent().removeClass("complete");
        if (Boss.ruleEngineItems().deviceType == null || Boss.ruleEngineItems().deviceType != 'tablet') {
            $(this).parent().addClass("disabled");
        }
    });
}

// Adds all the facet option image layers to the review callout section.
function updateImageLayers(result, oResultsContainer) {

    $('.imgReviewInitialBase').addClass('imgReviewPendingRemoval');
    $('.imgReviewPrevImageLayer').addClass('imgReviewPendingRemoval').removeClass('imgReviewPrevImageLayer');
    $('.imgReviewImageLayer').addClass('imgReviewPendingRemoval').removeClass('imgReviewImageLayer');

    // Update THD Image
    var thdDesktop = oResultsContainer.find('div.imagewrap');
    thdDesktop = thdDesktop.find('div.image-zoom');

    // Update TD Image
    var tdDesktop = oResultsContainer.find('div.thumbnail');
    tdDesktop = tdDesktop.find('div.image-zoom');

    // Update THD Modal
    var thdModal = oResultsContainer.parent().find('#zoom_dialog .dialogModal_content .overlays');

    // Update THD Mobile Modal
    var thdMobileModal = $('#zoom_dialog .dialogModal_content .overlays');

    // Update TD Modal
    var tdModal = $('#result_dialog_overlays');

    //Add images for previous facets, updating in place
    var prevImages = $.grep(result.ImageLayers, function (item) {
        return !item.CurrFacet || item.BaseImageLayer;
    });
    var lastPrevImageId = prevImages.length > 0 ? prevImages[prevImages.length - 1].ImageId : 0;
    $.each(prevImages, function () {
        var baseOrOverlay = this.BaseImageLayer ? 'base' : 'img-overlay';
        if (Boss.ruleEngineItems().deviceType == 'mobile') {
            thdDesktop.append('<img src="{0}" alt="{1}" class="{5} imgReviewPrevImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
            thdMobileModal.append('<img src="{0}" alt="{1}" class="{5} imgReviewPrevImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
        } else if (Boss.ruleEngineItems().deviceType == 'responsive') {
            tdDesktop.append('<img src="{0}" alt="{1}" class="{5} img-responsive imgReviewPrevImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
            tdModal.append('<img src="{0}" alt="{1}" class="{5} img-responsive imgReviewPrevImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
        } else {
            thdDesktop.append('<img src="{0}" alt="{1}" class="{5} imgReviewPrevImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
            thdModal.append('<img src="{0}" alt="{1}" class="{5} imgReviewPrevImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
        }
    });
    $('.imgReviewPrevImageLayer[data-imageid="' + lastPrevImageId + '"]').on('load', function () {
        $('.imgReviewPendingRemoval').hide();
        $('.imgReviewPendingRemoval').remove();
        $('.imgReviewPrevImageLayer').show();

    });

    //Add images for current facet, animated with fly in
    var facetImages = $.grep(result.ImageLayers, function (item) {
        return item.CurrFacet && !item.BaseImageLayer;
    });
    var lastCurrImageId = facetImages.length > 0 ? facetImages[facetImages.length - 1].ImageId : 0;
    $.each(facetImages, function () {
        var baseOrOverlay = this.BaseImageLayer ? 'base' : 'img-overlay';
        if (Boss.ruleEngineItems().deviceType == 'mobile') {
            thdDesktop.append('<img src="{0}" alt="{1}" class="{5} imgReviewImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
            thdMobileModal.append('<img src="{0}" alt="{1}" class="{5} imgReviewImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
        } else if (Boss.ruleEngineItems().deviceType == 'responsive') {
            tdDesktop.append('<img src="{0}" alt="{1}" class="{5} img-fluid imgReviewImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
            tdModal.append('<img src="{0}" alt="{1}" class="{5} img-fluid imgReviewImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
        } else {
            thdDesktop.append('<img src="{0}" alt="{1}" class="{5} imgReviewImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
            thdModal.append('<img src="{0}" alt="{1}" class="{5} imgReviewImageLayer" style="z-index: {2}; display:none;" data-imageid="{3}" data-facetid="{4}"/>'
                .format(this.ImageSrc, this.ImageAlt, this.ImageZIndex, this.ImageId, this.FacetId, baseOrOverlay));
        }
    });
    $('.imgReviewImageLayer[data-imageid="' + lastCurrImageId + '"]').on('load', function () {
        $('.imgReviewImageLayer').show('slow');
    });
}

// Cycle through products and update fields
function updateFields(result, oResultsContainer, currentFacetId) {
    // Update Title
    oResultsContainer.find('#cat-' + currentFacetId + ' .title span').text(result.Title);
    previousSelection = result.Title;
    displayProductHighlights(result.ProductHighlights);
    $('#cat-' + currentFacetId).show();

    if (result.ImageLayers != null) {
        // Add selections image layers to the review sections.
        updateImageLayers(result, oResultsContainer);
    }

    // Update Starting Price
    var lowestPrice = (result.Price.Price <= result.Price.PromoPrice
        ? result.Price.Price.toString()
        : result.Price.PromoPrice.toString());
    var stringLowestPrice = preciseRound(lowestPrice, 2);
    $('#lowestPrice').data('baseprice', stringLowestPrice);
    updatePrice(stringLowestPrice);
    var wasPrice = result.Price.Price - (result.Price.PromoPrice != 99999.00 ? result.Price.PromoPrice : result.Price.Price);
    if (wasPrice > 0) {
        promoPrices = [
            {
                optionId: currentFacetId,
                promoPrice: wasPrice
            }
        ];
        var wasPriceString = preciseRound(wasPrice.toString(), 2);
        $('#wasPrice').data('wasPrice', wasPriceString);
        updateWasPrice();
    } else {
        $('#wasPrice').text('');
    }
}

// Display the current products features
function displayProductHighlights(productHighlights) {
    $('.productFeature').remove();
    $.each(productHighlights, function (index, item) {
        if (Boss.ruleEngineItems().deviceType != null && Boss.ruleEngineItems().deviceType != 'responsive') {
            $('#cat-' + item.FacetId).append('<div class="productFeature included col-12"><i class="icon-carrot-orange"></i><span>   '
                + item.Title + '</span></div>');
        } else {
            $('#cat-' + item.FacetId).append('<div class="productFeature included col-12"><span class=\"fa fa-star-o\"></span> '
                + item.Title + '</div>');
        }
    });
}

// Cycle through products and update fields and display price values
function updateFieldsWithPrice(result, oResultsContainer, currentFacetId) {
    // Update Title
    oResultsContainer.find('#cat-' + currentFacetId + ' .title span').text(result.Title);
    previousSelection = result.Title;
    // Update Cost
    var lowestPrice = (result.Price.Price <= result.Price.PromoPrice
        ? result.Price.Price.toString()
        : result.Price.PromoPrice.toString());
    oResultsContainer.find('#cat-' + currentFacetId + ' .cost').text(preciseRound(lowestPrice, 2));
    $('#cat-' + currentFacetId).addClass('visible').show();
    // Update Starting Price
    updatePrice($('#lowestPrice').data('baseprice'));
    var wasPrice = result.Price.Price - (result.Price.PromoPrice != 99999.00 ? result.Price.PromoPrice : result.Price.Price);
    if (wasPrice > 0 || result.Price.Price == 0) {
        var exist = $.grep(promoPrices, function (obj) {
            return obj.optionId == currentFacetId;
        });
        if (exist.length > 0) {
            $.each(promoPrices, function () {
                if (this.optionId == currentFacetId) {
                    this.promoPrice = wasPrice;
                }
            });
        } else {
            promoPrices.push({
                optionId: currentFacetId,
                promoPrice: wasPrice
            });
        }
        var wasPriceString = preciseRound(wasPrice.toString(), 2);
        var totalPrice = $('#lowestPrice').data('totalprice');
        if (wasPriceString > totalPrice || wasPrice == 0) {
            $('#wasPrice').data('wasPrice', wasPriceString);
            updateWasPrice();
        }
    } else {
        $('#wasPrice').text('');
    }
}

// Cycle through products and update fields and display price values
function updateWarrantyPrice(result, oResultsContainer, currentFacetId, show, index) {
    // Update Title
    oResultsContainer.find('#cat-' + currentFacetId + '[data-index="' + index + '"] .title span').text(result.Title);
    previousSelection = result.Title;
    // Update Cost
    var lowestPrice = (result.Price.Price <= result.Price.PromoPrice
        ? result.Price.Price.toString()
        : result.Price.PromoPrice.toString());
    oResultsContainer.find('#cat-' + currentFacetId + '[data-index="' + index + '"] .cost').text(preciseRound(lowestPrice, 2));
    if (show == 'true') {
        $('#cat-' + currentFacetId + '[data-index="' + index + '"]').show();
        $('#cat-' + currentFacetId + '[data-index="' + index + '"]').addClass('visible');
    } else {
        $('#cat-' + currentFacetId + '[data-index="' + index + '"]').hide();
        $('#cat-' + currentFacetId + '[data-index="' + index + '"]').removeClass('visible');
    }
    // Update Starting Price
    updatePrice($('#lowestPrice').data('baseprice'));
    var wasPrice = result.Price.Price - (result.Price.PromoPrice != 99999.00 ? result.Price.PromoPrice : result.Price.Price);
    if (wasPrice > 0 || result.Price.Price == 0) {
        var exist = $.grep(promoPrices, function (obj) {
            return obj.optionId == currentFacetId;
        });
        if (exist.length > 0) {
            $.each(promoPrices, function () {
                if (this.optionId == currentFacetId) {
                    this.promoPrice = wasPrice;
                }
            });
        } else {
            promoPrices.push({
                optionId: currentFacetId,
                promoPrice: wasPrice
            });
        }
        var wasPriceString = preciseRound(wasPrice.toString(), 2);
        var totalPrice = $('#lowestPrice').data('totalprice');
        if (wasPriceString > totalPrice) {
            $('#wasPrice').data('wasPrice', wasPriceString);
            updateWasPrice();
        }
    } else {
        $('#wasPrice').text('');
    }
}

// Converts the specified number to a decimal with the specified number of decimal places
function preciseRound(num, decimals) {
    var sign = num >= 0 ? 1 : -1;
    return (Math.round((num * Math.pow(10, decimals)) + (sign * 0.001)) / Math.pow(10, decimals)).toFixed(decimals);
}

// Hides the specified facet review field
function hideFields(currentFacetId) {
    $('#cat-' + currentFacetId).hide();
}

// Update Starting Price
function updatePrice(startingPrice) {
    if (startingPrice !== null) {
        var totalPrice = Number(startingPrice);
        $('.item.visible .cost').each(function (i) {
            var value = $(this).text();
            if (value != null && value != '')
                totalPrice += Number(value.replace(/[^0-9\.]+/g, ""));
        });
        var price = String(preciseRound(totalPrice, 2)).split('.');
        $('#lowestPriceMobile').text(preciseRound(totalPrice, 2));
        $('#lowestPrice').text(price[0]);
        $('#lowestPriceCents').text(price[1]);
        $('#lowestPrice').data('totalprice', preciseRound(totalPrice, 2));
    }
}

// Updates the was price in the review callout
function updateWasPrice() {
    var total = 0;
    for (var i = 0; i < promoPrices.length; i++) {
        total = parseFloat(total) + parseFloat(promoPrices[i].promoPrice);
    }
    var totalPrice = Number($('#lowestPrice').data('totalprice'));
    totalPrice += total;
    var wasPrice = preciseRound(totalPrice, 2);
    var originalPrice = preciseRound($('#lowestPrice').data('totalprice'), 2);
    if (wasPrice != originalPrice) {
        $('#wasPrice').text(Boss.ruleEngineItems().promoPriceTitle + ' $' + wasPrice);
    } else {
        $('#wasPrice').text('');
    }
}

// Sets up the options page check boxes and the related review fields
function updateCheckboxes() {
    $('#custom-options input:checkbox').each(function (index) {
        var checkBox = $(this);
        let hidePrice = ($('#hidePrice').val().toLowerCase() === 'true');
        var oValue = checkBox.attr('value'),
            optionId = checkBox.attr('id'),
            oPrice = parseFloat(checkBox.data('price').replace(/[^0-9\.]+/g, "")),
            oPromoPrice = parseFloat(checkBox.data('promoprice') != null
                ? checkBox.data('promoprice').replace(/[^0-9\.]+/g, "")
                : '');

        var wasPrice = oPrice - (oPromoPrice != 99999.00 ? oPromoPrice : oPrice);
        var customContainer = $('#results-container #custom1');
        var listItems = $('#results-container #custom1 .item');
        if (/*!this.disabled && */listItems.filter('.' + optionId).length == 0) {
            if (!hidePrice) {
                customContainer.append('<div class="item clearfix ' + optionId +
                    '"><div class="row"><div class="title col-8">' +
                    oValue + '</div><div class="cost col-4">' + preciseRound(wasPrice > 0 ? oPromoPrice : oPrice, 2) + '</div></div></div>');
            }
            else {
                customContainer.append('<div class="item clearfix ' + optionId +
                    '"><div class="row"><div class="title col-8">' +
                    oValue + '</div></div></div>');
            }
        }
        checkboxChange(this);
    });
}

// Handles the checkbox options checked event.
function checkboxChange(chk) {
    var customContainer = $('#results-container #custom1');
    var listItems = $('#results-container #custom1 .item');
    var checked = chk.checked;
    var currentId = chk.id;
    var chkCurrent = $('#' + currentId);
    var install = chkCurrent.data('installid');
    if (install != null && install != '') {
        var installItem = $('.' + install);
        if (installItem != null) {
            var installData = installItem.attr('data-options');
            if (checked) {
                if (installData != null && installData.indexOf(currentId) < 0) {
                    installData = installData + currentId + ',';
                    installItem.attr('data-options', installData);
                } else {
                    installData = currentId + ',';
                    installItem.attr('data-options', installData);
                }
            } else {
                if (installData != null && installData.indexOf(currentId) >= 0) {
                    installData = installData.replace(currentId + ',', '');
                    installItem.attr('data-options', installData);
                }
            }
            var otherInstalls = $('.installation.visible');
        //    if (checked) {
        //        if (otherInstalls.length > 0) {
        //            var installCost = otherInstalls.find('.cost').text();
        //            if (installCost != null && installCost != '') {
        //                var ic = parseFloat(installCost);
        //                var cinstallCost = installItem.find('.cost').text();
        //                if (cinstallCost != null && cinstallCost != '' && parseFloat(cinstallCost) > ic) {
        //                    otherInstalls.toggle(false);
        //                    otherInstalls.removeClass('visible');
        //                    installItem.toggle(checked);
        //                    installItem.addClass('visible');
        //                }
        //            } else {
        //                otherInstalls.toggle(false);
        //                otherInstalls.removeClass('visible');
        //                installItem.toggle(checked);
        //                installItem.addClass('visible');
        //            }
        //        } else {
        //            installItem.toggle(checked);
        //            installItem.addClass('visible');
        //        }
        //    } else {
        //        if (installData == null || installData == '') {
        //            installItem.toggle(checked);
        //            installItem.removeClass('visible');
        //            otherInstalls = $('.installation:not([data-options=""])');
        //            otherInstalls.toggle(true);
        //            otherInstalls.addClass('visible');
        //        }
        //    }
        }
    }
    var resultsItem = listItems.filter('.' + currentId).appendTo(customContainer);
    resultsItem.toggle(checked);
    if (checked) {
        resultsItem.addClass('visible');
    } else {
        resultsItem.removeClass('visible');
    }
    toggleImageLayer(currentId, checked);
    var packageSelections = JSON.parse(JSON.stringify(currentPackagesSelected));
    $.each(packageSelections, function (i, val) {
        var optionsPackage = $('#' + val);
        if (optionsPackage != null) {
            var packageOptions = optionsPackage.data('package');
            if (packageOptions != null && packageOptions.indexOf(currentId) != -1 && !checked) {
                unselectCheckbox(optionsPackage);
            }
        }
    });
    if (checked && checkConflicts) {
        checkForConflictOptions($(chk));
    }
    if (_loopChk == null) {
        _loopChk = $(chk);
    }
    checkRequiredOptions($(chk), checked);
    if (_loopChk.id == $(chk).id) {
        _loopChk = null;
    }
    // Update Starting Price
    updatePrice($('#lowestPrice').data('baseprice'));
    var price = parseFloat(chk.getAttribute("data-price") != null
        ? chk.getAttribute("data-price").replace(/[^0-9\.]+/g, "") : '');
    var promoPrice = parseFloat(chk.getAttribute("data-promoprice") != null
        ? chk.getAttribute("data-promoprice").replace(/[^0-9\.]+/g, "") : '');
    var wasPrice = price - (promoPrice != 99999.00 ? promoPrice : price);
    if (wasPrice > 0 || $('#wasPrice').text() != '') {
        if (wasPrice > 0) {
            var exist = $.grep(promoPrices, function (obj) {
                return obj.optionId == currentId;
            });
            if (exist.length > 0) {
                if (checked) {
                    $.each(promoPrices, function () {
                        if (this.optionId == currentId) {
                            this.promoPrice = preciseRound(wasPrice.toString(), 2);
                        }
                    });
                } else {
                    promoPrices = $.grep(promoPrices, function (value) {
                        return value.optionId != currentId;
                    });
                }
            } else if (checked) {
                promoPrices.push({
                    optionId: currentId,
                    promoPrice: preciseRound(wasPrice.toString(), 2)
                });
            }
        }
        var wasPriceString = checked ? preciseRound(wasPrice.toString(), 2) : 0;
        $('#wasPrice').data('wasPrice', wasPriceString);
        updateWasPrice();
    }
}

// Handles the checkbox options checked event.
function packageChecked(chk) {
    var customContainer = $('#results-container #custom1');
    var listItems = $('#results-container #custom1 .item');
    var checked = chk.is(':checked');
    var currentId = chk.attr('id');
    listItems.filter('.' + currentId).appendTo(customContainer).toggle(checked);
    toggleImageLayer(currentId, checked);
    var packageSelections = JSON.parse(JSON.stringify(currentPackagesSelected));
    $.each(packageSelections, function (i, val) {
        var optionsPackage = $('#' + val);
        if (optionsPackage != null) {
            var packageOptions = optionsPackage.data('package');
            if (packageOptions != null && packageOptions.indexOf(currentId) != -1 && !checked) {
                unselectCheckbox(optionsPackage);
            }
        }
    });
    if (checked && checkConflicts) {
        checkForConflictOptions(chk);
    }
    checkRequiredOptions(chk, checked);

    // Update Starting Price
    updatePrice($('#lowestPrice').data('baseprice'));
    var price = parseFloat(chk.data("price") != null
        ? chk.data("price").replace(/[^0-9\.]+/g, "") : '');
    var promoPrice = parseFloat(chk.data("promoprice") != null
        ? chk.data("promoprice").replace(/[^0-9\.]+/g, "") : '');
    var wasPrice = price - (promoPrice != 99999.00 ? promoPrice : price);
    if (wasPrice > 0 || $('#wasPrice').text() != '') {
        if (wasPrice > 0) {
            var exist = $.grep(promoPrices, function (obj) {
                return obj.optionId == currentId;
            });
            if (exist.length > 0) {
                if (checked) {
                    $.each(promoPrices, function () {
                        if (this.optionId == currentId) {
                            this.promoPrice = wasPrice;
                        }
                    });
                } else {
                    promoPrices = jQuery.grep(promoPrices, function (value) {
                        return value.optionId != currentId;
                    });
                }
            } else {
                if (checked) {
                    promoPrices.push({
                        optionId: currentId,
                        promoPrice: wasPrice
                    });
                }
            }
        }
        var wasPriceString = preciseRound(wasPrice.toString(), 2);
        $('#wasPrice').data('wasPrice', wasPriceString);
        updateWasPrice();
    }
}

// Marks all the option package items as checked/unchecked based on the value specified.
function checkSelectedPackage(checkbox, iCheck) {
    if (typeof checkbox.data('package') !== 'undefined') {
        var iPackage = checkbox.data('package');
        checkConflicts = false;
        $.each(iPackage.split(','), function (i, val) {
            var iValue = $.trim(val);
            var chk = $('#' + iValue);
            if (!chk.is(':disabled')) {
                chk.prop('checked', (iCheck == 'true')).trigger('change');
                packageChecked(chk);
            }
        });
        if (partialLoad == false) {
            checkAllForConflictOptions();
        }
        checkConflicts = true;
    }
}

// Checks to see if there are any required options and if so check them too.
function checkRequiredOptions(chk, checked) {
    if (chk.data('requiredoptions') != null && chk.data('requiredoptions') != '' && !chk.disabled) {
        var requireds = String(chk.data('requiredoptions') ?? '');
        $.each(requireds.split(','), function (i, val) {
            var iValue = $.trim(val);
            if (iValue != null && iValue != '') {
                var required = $('#' + iValue);
                if (required != null) {
                    if (required.data('defaultoption') == "False") {
                        required.prop('checked', checked).prop('disabled', checked);
                        
                        var requiredoptions = String(required.data('requiredoptions') ?? '');
                        var requiredData = requiredoptions.split(',');
                        if (requiredData.indexOf(chk.attr('id') >= 0)
                            && chk.attr('disabled') == 'disabled') {
                            required.prop('disabled', false);
                        }
                        if (_loopChk.attr('id') != chk.attr('id')) {                            
                            required.change();
                        }
                        var customChk = required.next('.checkbox-custom');
                        var customContainer = $('#results-container #custom1');
                        var listItems = $('#results-container #custom1 .item');
                        var resultsItem = listItems.filter('.' + iValue).appendTo(customContainer);
                        resultsItem.toggle(checked);
                        if (customChk != null) {
                            if (checked) {
                                customChk.addClass('checkbox-custom-disabled-checked');
                                resultsItem.addClass('visible');
                            } else {
                                customChk.removeClass('checkbox-custom-disabled-checked');
                                resultsItem.removeClass('visible');
                            }
                        }
                    }
                }
            }
        });
    }
}

// Checks all the option check boxes for conflicts
function checkAllForConflictOptions() {
    $('#custom-options input:checkbox:checked:not(:disabled)').each(function (index) {
        var checkBox = $(this);
        var conflictOptions = String(checkBox.data('conflictingoptions') ?? '');

        $.each(conflictOptions.split(','), function (i, val) {
            var iValue = $.trim(val);
            if (iValue != null && iValue != '') {
                var conflict = $('#' + iValue + ':checked');
                if (conflict != null && conflict.length > 0) {
                    var title = checkBox.data('conflicttitle'),
                        message = checkBox.data('conflictmessage'),
                        exceptionModal = $('#exception_dialog'),
                        exceptionTitle = $('#exception_dialog .dialogModal_header'),
                        exceptionMessage = $('#exception_dialog .dialogModal_content');
                    exceptionTitle.text(title);
                    exceptionMessage.html(message);
                    exceptionModal.dialogModal({
                        onOkBut: function () { },
                        onCancelBut: function () {
                            //uncheck selection
                            checkConflicts = false;
                            checkBox.prop('checked', false).change();
                            checkConflicts = true;
                        }
                    });
                    $('.dialogModal').addClass('warning-modal');
                }
            }
        });
    });
}

// Checks the specified check box for conflicts with the other check boxes
function checkForConflictOptions(checkBox) {
    if (checkBox.data('conflictingoptions') != null
            && checkBox.data('conflictingoptions') != ''
            && !checkBox.disabled) {
        var conflicts = String(checkBox.data('conflictingoptions') ?? '');
        $.each(conflicts.split(','), function (i, val) {
            var iValue = $.trim(val);
            if (iValue != null && iValue != '') {
                var conflict = $('#' + iValue + ':checked:not(:disabled)');
                if (conflict != null && conflict.length > 0) {
                    var title = checkBox.data('conflicttitle'),
                        message = checkBox.data('conflictmessage'),
                        exceptionModal = $('#exception_dialog'),
                        exceptionTitle = '',
                        exceptionMessage = '';
                    if (exceptionModal != null && exceptionModal.length > 0) {
                        exceptionTitle = $('#exception_dialog .dialogModal_header');
                        exceptionMessage = $('#exception_dialog .dialogModal_content');
                        exceptionTitle.text(title);
                        exceptionMessage.html(message);
                        exceptionModal.dialogModal({
                            onOkBut: function () { },
                            onCancelBut: function () {
                                //uncheck selection
                                checkConflicts = false;
                                checkBox.prop('checked', false).change();
                                checkConflicts = true;
                            }
                        });
                        $('.dialogModal').addClass('warning-modal');
                    } else {
                        exceptionModal = $('#conflictModal');
                        exceptionTitle = $('#conflictTitle');
                        exceptionMessage = $('#conflictBody');
                        var confirmButton = $('#btnConflictConfirm');
                        confirmButton.data('checkboxid', checkBox.attr('id'));
                        exceptionTitle.text(title);
                        exceptionMessage.html(message);
                        exceptionModal.modal('show');
                    }
                }
            }
        });
    }
    $('#custom-options input:checkbox:checked:not(:disabled)').each(function (index) {
        var chk = $(this);
        if (!chk.disabled) {
            var conflictOptions = String(checkBox.data('conflictingoptions') ?? '');
            if (conflictOptions != null && conflictOptions.indexOf(checkBox.attr('id')) >= 0) {
                var title = chk.data('conflicttitle'),
                        message = chk.data('conflictmessage'),
                        exceptionModal = $('#exception_dialog'),
                        exceptionTitle = '',
                        exceptionMessage = '';
                if (exceptionModal != null && exceptionModal.length > 0) {
                    exceptionTitle = $('#exception_dialog .dialogModal_header');
                    exceptionMessage = $('#exception_dialog .dialogModal_content');
                    exceptionTitle.text(title);
                    exceptionMessage.html(message);
                    exceptionModal.dialogModal({
                        onOkBut: function () { },
                        onCancelBut: function () {
                            //uncheck selection
                            checkConflicts = false;
                            checkBox.prop('checked', false).change();
                            checkConflicts = true;
                        }
                    });
                    $('.dialogModal').addClass('warning-modal');
                } else {
                    exceptionModal = $('#conflictModal');
                    exceptionTitle = $('#conflictTitle');
                    exceptionMessage = $('#conflictBody');
                    var confirmButton = $('#btnConflictConfirm');
                    confirmButton.data('checkboxid', checkBox.attr('id'));
                    exceptionTitle.text(title);
                    exceptionMessage.html(message);
                    exceptionModal.modal('show');
                }
            }
        }
    });
}

// Sets all the currently selected options to checked.
function checkSelectedOptions() {
    $.each(currentOptions, function (i, val) {
        $('#' + val).attr("checked", true).change();
    });
}

// Sets all the currently selected options to checked.
function checkSelectedWarranties(warrantySelections) {
    $.each(warrantySelections, function (i, val) {
        $('#' + val.FacetOptionId + '[data-index="' + val.DataIndex + '"]').attr("checked", true).change();
    });
}

// Unchecks all the option check boxes. 
function uncheckSelectedOptions() {
    $('#custom-options input:checkbox:checked').each(function (index) {
        $(this).prop('checked', false).trigger('change');
    });
}

// Unchecks the specified package check box
function unselectCheckbox(checkbox) {
    checkbox.prop('checked', false);
    checkbox.closest('.panel').toggleClass('active');
    var id = checkbox.attr('id');
    checkbox.next('.checkbox-custom-active').removeClass('checkbox-custom-active').addClass('checkbox-custom');
    if ($.inArray(id, currentPackagesSelected) >= 0) {
        currentPackagesSelected.splice($.inArray(id, currentPackagesSelected), 1);
    }
}

// Grabs all the currently selected option check boxes and loads them into the current options selected array
function updateCurrentOptions(currentOptions) {
    $('#custom-options input:checkbox:checked').each(function (index) {
        var optionId = $(this).attr('id');
        currentOptions.push(optionId);
    });
}

// Loads the image layers into the review callout tab for display later.
function loadImageLayers(imageLayers) {
    if (imageLayers != null && imageLayers.length > 0) {
        $.each(imageLayers, function (i, val) {
            if (val.ImageSrc != null && val.ImageSrc != '' && $('#img' + val.OptionId).length == 0) {
                var imageControl = '<img id="img' + val.OptionId +
                    '" src="' + val.ImageSrc +
                    '" alt="' + val.ImageAlt +
                    '" class="img-overlay img-Option' +
                    '" style="z-index: ' + val.ImageZIndex + '; display: none;" />';
                $('#results-container .image-zoom').append(imageControl);
                imageControl = '<img id="imgM' + val.OptionId +
                    '" src="' + val.ImageSrc +
                    '" alt="' + val.ImageAlt +
                    '" class="img-overlay img-Option' +
                    '" style="z-index: ' + val.ImageZIndex + '; display: none;" />';
                $('#zoom_dialog .dialogModal_content .overlays').append(imageControl);
                $('#result_dialog_overlays').append(imageControl);
            }
        });
    }
}

// Loads the possible installations into the review panel
function loadInstallations(installs) {
    var lateralModal = $('#lateral_dialog');
    if (lateralModal.data('responsive') != null) return;
    var customContainer = $('#results-container #custom1');
    if (installs != null && installs.length > 0) {
        $.each(installs, function (i, val) {
            if (val.NoInstallationFee == false) {
                var oValue = val.ReviewTitle,
                    optionId = val.Id,
                    oPrice = parseFloat(val.Price.Price),
                    oPromoPrice = val.Price.PromoPrice != null && val.Price.PromoPrice != 99999.00 ? val.Price.PromoPrice : val.Price.Price;
                oPrice = preciseRound(oPrice.toString(), 2);
                oPromoPrice = preciseRound(oPromoPrice.toString(), 2);
                var wasPrice = oPrice - (oPromoPrice != 99999.00 ? oPromoPrice : oPrice);
                var listItems = $('#results-container #custom1 .item');
                if (listItems.filter('.' + optionId).length == 0) {
                    customContainer.append('<div class="item clearfix installation ' + optionId +
                        '" data-options=""><div class="row"><div class="title col-8">' +
                        oValue + ' <i class="icon-wrench-prem"></i></div><div class="cost col-4">' +
                        preciseRound(wasPrice > 0 ? oPromoPrice : oPrice, 2) + '</div></div></div>');
                    $('.' + optionId).toggle(false);
                }
            }
        });
    }
}

// Toggles the visibility of the selected image layer.
function toggleImageLayer(id, isChecked) {
    if (isChecked) {
        $('#img' + id).show('slow');
        $('#imgM' + id).show('slow');
    } else {
        $('#img' + id).hide('slow');
        $('#imgM' + id).hide('slow');
    }
}